import { render, staticRenderFns } from "./AffairCarUser.vue?vue&type=template&id=59385e92"
import script from "./AffairCarUser.vue?vue&type=script&lang=js"
export * from "./AffairCarUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports